import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as ArrowRightIcon } from "common/assets/icons/chevron-right.svg";
import { P } from "common/P/P";

interface BreadcrumbItem {
	label: string | number;
	path?: string;
}

interface BreadcrumbsProps {
	items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
	return (
		<nav
			aria-label="breadcrumbs"
			className="grid grid-flow-col gap-2 auto-cols-max h-max place-items-center"
		>
			{items.map((item, index) => (
				<React.Fragment key={index}>
					{index > 0 && <ArrowRightIcon className="w-4 h-4" />}
					{item.path && index !== items.length - 1 ? (
						<Link to={item.path}>
							<P size="t1" type="regular" className="cursor-pointer">
								{item.label}
							</P>
						</Link>
					) : (
						<P size="t1" type="medium">
							{item.label}
						</P>
					)}
				</React.Fragment>
			))}
		</nav>
	);
};

export default Breadcrumbs;
